export default __webpack_public_path__ + "static/media/Logo-RACE-Raja-Cepat.336ffaf4.png";